'use client';

import React from 'react';
import { IdView } from '../../../../components';
import { RevshareTransaction } from '../types';

interface IdCellProps {
  transaction: RevshareTransaction;
}

const IdCell: React.FC<IdCellProps> = ({ transaction }) => {
  // Use of_id as the transaction ID, fallback to id
  const idString = transaction.id?.toString() || transaction.id || transaction._id || '';
  const displayId = idString.slice(-4);

  return (
    <div className="flex items-center">
      <IdView textToCopy={idString}>{displayId}</IdView>
    </div>
  );
};

export default IdCell;
